import { render } from "./InfoComponent.vue?vue&type=template&id=37fb30c8"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"

import "./InfoComponent.vue?vue&type=style&index=0&id=37fb30c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__